// Palette colori per i clienti - Forfy Sunset Calm
// Ogni colore ha: bg (Tailwind class), hex (per SVG), light (per background chiari)
const CLIENT_COLORS = [
  { bg: 'bg-[#FFAA85]', hex: '#FFAA85', light: 'bg-[#FFF5F0]' },  // Forfy primary
  { bg: 'bg-[#22C55E]', hex: '#22C55E', light: 'bg-green-100' },   // Green
  { bg: 'bg-[#3B82F6]', hex: '#3B82F6', light: 'bg-blue-100' },    // Blue
  { bg: 'bg-[#A855F7]', hex: '#A855F7', light: 'bg-purple-100' },  // Purple
  { bg: 'bg-[#EC4899]', hex: '#EC4899', light: 'bg-pink-100' },    // Pink
  { bg: 'bg-[#14B8A6]', hex: '#14B8A6', light: 'bg-teal-100' },    // Teal
  { bg: 'bg-[#FF8A5C]', hex: '#FF8A5C', light: 'bg-[#FFCDB8]' },   // Forfy dark
  { bg: 'bg-[#EAB308]', hex: '#EAB308', light: 'bg-yellow-100' },  // Yellow
  { bg: 'bg-[#EF4444]', hex: '#EF4444', light: 'bg-red-100' },     // Red
  { bg: 'bg-[#06B6D4]', hex: '#06B6D4', light: 'bg-cyan-100' },    // Cyan
];

export const OTHERS_COLOR = { bg: 'bg-neutral-400', hex: '#A3A3A3', light: 'bg-neutral-100' };

// Genera un hash consistente dal nome del cliente
// Usa un algoritmo più robusto per distribuire meglio i colori
const hashString = (str) => {
  let hash = 0;
  const normalized = str.toLowerCase().trim();
  for (let i = 0; i < normalized.length; i++) {
    const char = normalized.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
};

// Ottieni il colore per un cliente (SEMPRE lo stesso per lo stesso nome)
export const getClientColor = (clientName) => {
  if (!clientName) {
    return CLIENT_COLORS[0];
  }
  const hash = hashString(clientName);
  return CLIENT_COLORS[hash % CLIENT_COLORS.length];
};

// Ottieni le iniziali del cliente
export const getClientInitials = (clientName) => {
  if (!clientName) return "??";
  return clientName
    .split(' ')
    .map(n => n[0])
    .filter(Boolean)
    .join('')
    .toUpperCase()
    .slice(0, 2) || "??";
};

// Esporta anche la palette per usi speciali (es. "Altri" nella torta)
export { CLIENT_COLORS };
